import React, { useState } from 'react';
import Footer from "../components/common/footer";
import SEOHelmet from "../components/common/SEOHelmet";
import { generateServiceSchema, generateWebPageSchema } from "../utils/schemaGenerators";
import INFO from "../data/user";
import SEO from "../data/seo";

import "./styles/services.css";

const servicesList = [
    {
        id: 1,
        title: "Balayage & Highlights",
        description: "Expert balayage and highlights using hand-painted techniques for natural-looking, dimensional color that grows out beautifully. Perfect for brunettes and blondes seeking low-maintenance, sun-kissed results.",
        price: "Starting at $200",
        duration: "3-4 hours",
        serviceId: "30329769",
        image: "/photo1.avif"
    },
    {
        id: 2,
        title: "Color Correction",
        description: "Professional color correction services to fix uneven color, brass, or unwanted tones and restore a beautiful, balanced shade. Consultation required.",
        price: "Starting at $250",
        duration: "4-6 hours",
        image: "/pexels-photo-3993315.avif"
    },
    {
        id: 3,
        title: "Women's Haircut",
        description: "Professional women's haircuts with precision cuts customized to your face shape, hair texture, and lifestyle. Includes consultation, wash, and style.",
        price: "$85",
        duration: "1 hour",
        image: "/pexels-photo-3993466.avif"
    },
    {
        id: 4,
        title: "Men's Haircut",
        description: "Expert men's haircuts including modern styles, fades, and classic looks. Includes consultation and styling.",
        price: "$65",
        duration: "45 minutes",
        image: "/pexels-photo-897262.avif"
    },
    {
        id: 5,
        title: "Keratin Treatment",
        description: "Smoothing treatments to reduce frizz and make hair more manageable. Results last 3-6 months.",
        price: "Starting at $300",
        duration: "2-3 hours",
        image: "/pexels-photo-3993312.avif"
    }
];

const Services = () => {
    const [loadingService, setLoadingService] = useState(null);
    const currentSEO = SEO.find(item => item.page === "services");
    
    // Generate schema for all services
    const servicesSchema = servicesList.map(service => generateServiceSchema(service));
    const pageSchema = [
        ...servicesSchema,
        generateWebPageSchema({
            title: "Haircuts, Color & Highlights in Northern Virginia",
            description: currentSEO?.description,
            url: `${INFO.socials.website}/services`
        }),
        {
            "@context": "https://schema.org",
            "@type": "ItemList",
            "itemListElement": servicesList.map((service, index) => ({
                "@type": "ListItem",
                "position": index + 1,
                "item": {
                    "@type": "Service",
                    "name": service.title,
                    "description": service.description,
                    "offers": {
                        "@type": "Offer",
                        "price": service.price,
                        "priceCurrency": "USD"
                    }
                }
            }))
        }
    ];

    const handleBooking = async (service) => {
        setLoadingService(service.id);
        try {
            const vagaroUrl = new URL(INFO.socials.instagram);
            window.open(vagaroUrl.toString());
        } catch (error) {
           console.error('Error opening URL:', error);
        } finally {
            setLoadingService(null);
        }
    };

    return (
        <React.Fragment>
            <SEOHelmet
                title="Haircuts, Hair Color & Highlights in Falls Church, McLean, Vienna & Reston"
                description="Professional hair services in Falls Church, McLean, Vienna, Reston & Tysons. Women's haircuts $85, hair coloring, highlights & balayage starting at $200. Serving Fairfax County & Northern Virginia. Book your haircut, color or highlights near you today!"
                keywords={currentSEO?.keywords.join(", ")}
                schema={pageSchema}
            />

            <div className="page-content">
                <div className="content-wrapper">
                    <div className="services-container">
                        <div className="title services-title">
                            Haircuts, Hair Color & Highlights in Falls Church, McLean, Vienna & Reston
                        </div>
                        <div className="subtitle services-subtitle">
                            Women's haircuts, hair coloring, highlights & balayage. Serving Falls Church, McLean, Vienna, Reston, Fairfax County and Northern Virginia with expert care and precision.
                        </div>

                        <div className="services-list">
                            {servicesList.map(service => (
                                <div key={service.id} className="service-card">
                                    <div className="service-image-container">
                                        <img 
                                            src={service.image} 
                                            alt={`${service.title} service at Pasmo Beauty Lab in Falls Church`}
                                            className="service-image"
                                            loading="lazy"
                                            width="400"
                                            height="300"
                                        />
                                    </div>
                                    <div className="service-content">
                                        <h2 className="service-title">{service.title}</h2>
                                        <p className="service-description">{service.description}</p>
                                        <div className="service-details">
                                            <span className="service-price">{service.price}</span>
                                            <span className="service-duration">{service.duration}</span>
                                        </div>
                                        <button 
                                            onClick={() => handleBooking(service)}
                                            disabled={loadingService === service.id}
                                            className="book-service-button"
                                        >
                                            {loadingService === service.id ? 'Loading...' : 'Book Now'}
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    
                    <div className="page-footer">
                        <Footer />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Services; 